import {
  NationalityResponse,
  ValidateSanctionCountryRequest,
} from '@/types/Nationality';
import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInterceptorInstance from './axiosInterceptorInstance';
import { getCountryCode } from '@/helpers/CountryCodeHelper';

export const getNationalityList = createAsyncThunk(
  'nationality/getNationalityList',
  async (language: string) => {
    try {
      const relativeUrl = 'Nationality/GetNationalityList?language=' + language;
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const validateSanctionCountry = createAsyncThunk(
  'screening/ValidateSanctionCountry',
  async (nationality: NationalityResponse) => {
    try {
      const request: ValidateSanctionCountryRequest = {
        sourceAppName: 'EDP_MotorFE',
        sourceReference: '',
        countryIsoCode: nationality.isO3Code,
        countryCode: getCountryCode()
      };
      const relativeUrl = 'MDMScreening/ValidateSanctionCountry';
      const apiUrl = `/screening/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);
